import { fetchFromObject } from 'helpers/object';

export default {
  dataCampaign: state => field => state[field],

  getNewCampaignDataField: state => field => fetchFromObject(state, field),

  isNonEditableField: state => field => {
    const nonEditableFields = state.campaignDetail ? state.campaignDetail.nonEditableFields : null;
    return nonEditableFields && nonEditableFields.indexOf(field) > -1;
  }
};
